import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/../public/media/logos/logo_AgriBEST_300dpi_color.png'


const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header card-header-jaya border-primary" }
const _hoisted_3 = { class: "card-body border-top p-5 p-md-9" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 d-flex flex-center\"><img src=\"" + _imports_0 + "\" alt=\"Logo - AgriBEST\" style=\"object-fit:contain;filter:opacity(1);\" class=\"rounded-2 mh-150px\"></div><p class=\"fw-bold text-center fs-4 pb-5\"> Faites une auto-évaluation à 360 degrés de vos pratiques agricoles pour une première marche biodiversité </p><ul class=\"list-group text-center pb-10\"><li class=\"list-group-item\"> Comprendre et évaluer les effets – positifs, neutres ou négatifs – de vos pratiques sur la Biodiversité et les services écosystémiques que vous générez, sans vous juger ni vous contraindre </li><li class=\"list-group-item\"> Identifier et visualiser les voies de progrès pour favoriser la préservation de la biodiversité, en vous laissant le choix dans les évolutions possibles, souhaitables et désirées </li><li class=\"list-group-item\"> Générer des données pour valoriser vos actions, dialoguer avec vos parties prenantes et communiquer </li></ul>", 3)
const _hoisted_7 = { class: "w-100 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_title_jaya, {
        "duotune-icon": "general/gen045",
        title: "AgriBEST, qu'est ce que c'est ?"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleVideos, (moduleVideo) => {
        return (_openBlock(), _createElementBlock("div", {
          key: moduleVideo.id,
          class: "pb-10"
        }, [
          _createElementVNode("div", _hoisted_7, [
            (moduleVideo.video.url)
              ? (_openBlock(), _createBlock(_component_VideoComponent, {
                  key: 0,
                  class: "mw-500px",
                  "video-url": moduleVideo.video.url,
                  onlineVideoUrl: moduleVideo.video.online_url,
                  style: {"height":"300px"}
                }, null, 8, ["video-url", "onlineVideoUrl"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}